/**
 * User-facing copy for R1 Q2: the AI's questions in the panel, on the document
 * overview and in the Submission Pack.
 *
 * PLACEHOLDER until Kapil's hand test. Every string for this feature lives here
 * so a wording change is one edit. AU English; the current user is "You".
 */

/** The recommended option's reason line: "Recommended · {reason}". */
export const QUESTION_RECOMMENDED = 'Recommended'
export const QUESTION_ANSWER_PLACEHOLDER = 'Type your answer'
export const QUESTION_ANSWER_LABEL = 'Your answer'
/** The only save action, when updating the draft from an answer is not offered. */
export const QUESTION_SAVE = 'Save answer'
/** The main save action: save the answer and update the sections it affects (`update_draft`). */
export const QUESTION_SAVE_AND_UPDATE = 'Save and update draft'
/** Beside "Save and update draft": save the answer, leave the draft (`answer_only`). */
export const QUESTION_SAVE_ONLY = 'Save only'
/** Defer: the question stays waiting. */
export const QUESTION_SKIP = 'Skip for now'
/** The chat line and the Submission Pack's word for a deferred question. */
export const QUESTION_NOT_KNOWN = 'Not known yet'
export const QUESTION_SAVING = 'Saving…'

/** A deferred question ("Skip for now") still waiting for an answer. */
export const QUESTION_DEFERRED = 'You skipped this for now.'

/** A row's state once the question has an answer. */
export const QUESTION_ANSWERED_STATE = 'Answered'

/**
 * Plain helper lines for the fixed reasons the server writes (see
 * `plainQuestionReason` in `question-view.ts`). Any other reason is shown as written.
 */
export const QUESTION_REASON_NOT_FOUND = "We couldn't find this in your documents."
/** The draft already states it; nothing in the documents backs it. */
export const QUESTION_REASON_UNSUPPORTED = "The draft says this, but we couldn't find it in your documents."
export const QUESTION_REASON_UNCONFIRMED = "Your documents don't confirm this. Only your team can settle it."

/** Outcomes of "Save and update draft". */
export const QUESTION_UPDATE_STARTED = 'Updating the draft with your answer.'
/** `busy`: another drafting job holds the document. Used when the server sends no message. */
export const QUESTION_UPDATE_AFTER_CURRENT =
  'Your answer is saved. The draft will be updated with it when the current drafting finishes.'
/** `unavailable`: the whole-document job is switched off; saved only (R1 J8′). Used when the server sends no message. */
export const QUESTION_UPDATE_UNAVAILABLE =
  "Your answer is saved. Updating the draft from an answer isn't available yet, so the draft was not changed."
/** `no_targets`: nothing the AI may update. The skipped reasons follow. */
export const QUESTION_UPDATE_NOTHING = "Your answer is saved. The AI can't update any of the sections it affects."

/** Heading over the sections an update skipped; each reason line comes from the server. */
export const QUESTION_SKIPPED_HEADING = 'Not updated:'

/** A panel answer the turn did not record (the AI still read it). Same words as the PATCH route's 409s. */
export const QUESTION_NOT_RECORDED_SUPERSEDED =
  'This question was replaced by a newer one, so your answer was not saved here.'
export const QUESTION_NOT_RECORDED_ALREADY_ANSWERED =
  'This question already has an answer. Change the answer instead.'

/** Any failure the server did not explain. */
export const QUESTION_SAVE_FAILED = "Couldn't save your answer. Try again."
export const QUESTION_LIST_FAILED = "Couldn't load the questions for this document."

/** Document overview list. */
export const QUESTIONS_HEADING = 'Questions for your team'
/** Beside the heading, over its progress bar. */
export const QUESTIONS_ANSWERED_COUNT = '{answered} of {total} answered'

/** The AI panel's pointer to the overview's list (the questions live there only). */
export const PANEL_QUESTIONS_COUNT_ONE = '1 question for your team'
export const PANEL_QUESTIONS_COUNT_MANY = '{count} questions for your team'
export const PANEL_QUESTIONS_ANSWERED = '{answered} answered'
export const PANEL_QUESTIONS_LINK = 'Answer on page'

/** Submission Pack "Waiting on the team" row prefix. */
export const PACK_QUESTION_PREFIX = 'Question: '

export function fillCopy(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match
  )
}
